import { render, staticRenderFns } from "./intelligentAnswering_v2.vue?vue&type=template&id=4b7dd8d2&scoped=true&"
import script from "./intelligentAnswering_v2.vue?vue&type=script&lang=js&"
export * from "./intelligentAnswering_v2.vue?vue&type=script&lang=js&"
import style0 from "./intelligentAnswering_v2.vue?vue&type=style&index=0&id=4b7dd8d2&prod&scoped=true&lang=scss&"
import style1 from "./intelligentAnswering_v2.vue?vue&type=style&index=1&id=4b7dd8d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dd8d2",
  null
  
)

export default component.exports